<template>
    <div class="main-container">
        <div class="player-container">
            <Header v-if="!$route.query.iframe"/>
            <PlayerWrapper/>
        </div>
        <div class="controls-container" v-if="!$route.query.iframe">
            <div class="controls-share-video-title">
                <div class="title-style-1">SHARE THE MOMENT</div>
                WITH FAMILY &#38; FRIENDS
            </div>
            <SocialSharing v-if="!$route.query.iframe"/>
            <DownloadApp v-if="!$route.query.iframe"/>
        </div>
        <Carousel/>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import * as types from '../../store/actionTypes';
import Header from "../../components/Header";
import PlayerWrapper from './PlayerWrapper';
import SocialSharing from './SocialSharing';
import DownloadApp from "./DownloadApp";
import Carousel from './Carousel';
import preloadImages from '../../helpers/preloadImages';

export default {
    name: 'Main',
    components: {
        Header,
        PlayerWrapper,
        SocialSharing,
        Carousel,
        DownloadApp
    },
    props: {
        hash: { type: String },
        type: { type: String }
    },
    data() {
        return {
            videoData: null,
        }
    },
    mounted() {
        this.loadWebSDK();

        preloadImages();

        this.mainFetch({ hash: this.hash });
    },
    methods: {
        ...mapActions({
            mainFetch: `main/${types.MAIN_FETCHING_ACTION}`,
            loadWebSDK: `asyncLoading/${types.LOAD_WEB_SDK_REQUEST}`
        }),
    }
}
</script>
